<template>
    <div>
        {{ body }}
    </div>
</template>

<script>
import { ref } from 'vue';
import { getPauseInfo } from '@/apis/notice';

export default {
    setup() {
        const body = ref('');

        getPauseInfo().then(response => {
            body.value = response.data.body;
        }).catch(() => {
            body.value = '系統將目前進行系統維護作業，敬請見諒！';
        });

        return {
            body
        };
    }
};
</script>
